import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { I18nModule } from "@spartacus/core";
import { RestrictionPopupComponent } from "./restriction-popup.component";




@NgModule({
  declarations: [RestrictionPopupComponent],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    I18nModule,
    FormsModule,
  ] ,
  exports:[RestrictionPopupComponent]
})
export class RestrictionPopupModule { }
